import { routes } from '../../assets/constants';
import { useApi } from './use-api.hook';
import { ApiMethod } from '../models/api-types.type';
import {
  ProductType,
  CreateProductTypePayload,
  UpdateProductTypePayload,
} from '../models/product-type.model';

export const useProductTypesApi = () => {
  const { sendProtectedRequest } = useApi();

  const findAllProductTypes = async (
    params?: { activeOnly?: boolean }
  ): Promise<ProductType[]> => {
    const queryParams = new URLSearchParams();
    if (params?.activeOnly) {
      queryParams.append('activeOnly', 'true');
    }
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const response = await sendProtectedRequest(
      ApiMethod.GET,
      `${routes.productTypes.findAll}${query}`
    );
    return response || [];
  };

  const findOneProductType = async (id: string): Promise<ProductType | null> => {
    const response = await sendProtectedRequest(
      ApiMethod.GET,
      routes.productTypes.findOne(id)
    );
    return response || null;
  };

  const createProductType = async (
    payload: CreateProductTypePayload
  ): Promise<ProductType> => {
    const response = await sendProtectedRequest(
      ApiMethod.POST,
      routes.productTypes.create,
      payload
    );
    return response;
  };

  const updateProductType = async (
    id: string,
    payload: UpdateProductTypePayload
  ): Promise<ProductType> => {
    const response = await sendProtectedRequest(
      ApiMethod.PATCH,
      routes.productTypes.patch(id),
      payload
    );
    return response;
  };

  const deleteProductType = async (id: string): Promise<void> => {
    await sendProtectedRequest(ApiMethod.DELETE, routes.productTypes.deleteOne(id));
  };

  return {
    findAllProductTypes,
    findOneProductType,
    createProductType,
    updateProductType,
    deleteProductType,
  };
};
